import { FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";

import { ImportTypeConfig } from "domains/stock-transfer-imports/types";
import importTypeConfigFile from "domains/stock-transfer-imports/services/importConfig.json";
import localisations from "features/localisation";
import { useState } from "react";

type Props = {
    onImportTypeConfigSelected?: (importTypeConfig: ImportTypeConfig | undefined) => void;
    selectedImportTypeConfig: ImportTypeConfig | undefined;
};

function localise(loc: any, field: string | undefined, code: string): string | undefined {
    const fallback = undefined;

    if (!field) {
        return fallback;
    }

    let dotPos = field.indexOf(".");
    if (dotPos > -1) {
        field = field.substring(dotPos + 1);
    }

    if (!loc) return fallback;
    if (!loc[field]) return fallback;
    return loc[field][code] || loc[field].default || fallback;
}

const ImportTypeStage = (props: Props) => {
    const { selectImportType: localisation } = localisations.stockTransferImport.stages;

    const { onImportTypeConfigSelected, selectedImportTypeConfig } = props;

    const [importTypeConfigurations] = useState<ImportTypeConfig[]>(importTypeConfigFile);

    const handleChange = (event: SelectChangeEvent<string>) => {
        const selected = importTypeConfigurations.find((x) => x.id.toString() === event.target.value.toString());

        onImportTypeConfigSelected?.(selected);
    };

    return (
        <>
            <Typography marginBottom={3} variant="h5" gutterBottom>
                {localisation.heading}
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControl variant="outlined" sx={{ minWidth: 400 }}>
                        <InputLabel>{localisation.selectText}</InputLabel>
                        <Select
                            value={selectedImportTypeConfig?.id.toString() ?? ""}
                            onChange={handleChange}
                            label={localisation.selectText}
                        >
                            {importTypeConfigurations.map((config) => {
                                const name = localise(localisation, config.importType, "importTypeName");
                                return (
                                    name && (
                                        <MenuItem key={config.id} value={config.id}>
                                            {name}
                                        </MenuItem>
                                    )
                                );
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                        {localise(localisation, selectedImportTypeConfig?.importType, "description")}
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
};

export default ImportTypeStage;
